module.exports = __webpack_public_path__ + "img/PRCA2_TMKI67.c4861d53.png";